import {Component, input} from '@angular/core';
import {TenderDetailResponse} from '@frontend/shared-api';
import {TrustedTextPreviewComponent} from '../../../../../shared/components/text/text-preview/trusted-text-preview.component';
import {SubsectionTitleComponent} from '../../../../../shared/components/header/subsection-title/subsection-title.component';

@Component({
  selector: 'app-tender-project-rfq-guidance',
  imports: [TrustedTextPreviewComponent, SubsectionTitleComponent],
  templateUrl: './tender-rfq-guidance.component.html',
})
export class TenderRfqGuidanceComponent {
  tenderDetails = input<TenderDetailResponse>();
}
